import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiCheck, FiArrowRight } = FiIcons;

function PricingSection() {
  return (
    <section className="pricing-section section-pad" id="pricing">
      <div className="pricing-card page-width">
        <div className="pricing-copy">
          <span className="eyebrow eyebrow-light">Simple, clear pricing</span>
          <h2>One hour can change<br />how you feel on the road.</h2>
          <p>Focused, supportive automatic driving instruction, with a clear hourly rate.</p>
          <div className="pricing-includes"><SafeIcon icon={FiCheck} /> Personalised lesson <SafeIcon icon={FiCheck} /> Automatic dual-control vehicle</div>
          <a className="button button-white" href="tel:0433037815">Book a lesson <SafeIcon icon={FiArrowRight} /></a>
        </div>
        <motion.div className="price-display" initial={{ opacity: 0, scale: 0.92 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <span className="price-label"><SafeIcon icon={FiClock} /> DRIVING LESSON</span>
          <strong><sup>$</sup>75</strong>
          <span className="price-unit">per hour</span>
          <div className="price-rule" />
          <span className="price-note">Learn fast. Feel confident.</span>
        </motion.div>
      </div>
    </section>
  );
}

export default PricingSection;